var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-analysis-outer"},[_c('BlockTitle',{attrs:{"title":"资产用途"}}),_c('div',{staticClass:"chart-canvas",attrs:{"id":"chartDom"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }